import { Component, OnInit, ViewChild } from '@angular/core';
import { GrIrService } from '../../../../service/gr-ir/gr-ir.service';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { PurchaseOrderService } from '../../../../service/vendor/purchase-order.service';
import { TreeTable } from 'primeng/treetable';
import { VendorFieldsDTOForGR,POFieldsDTOForGR,GRSearchDTO } from '../../../../models/grLineItemSearchDTO';
import * as XLSX from 'xlsx';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';

interface Column {
  field: string;
  defaultFilter: string;
}
interface ItemElement {
  item: any;
  shipments: any[];
}

interface FilterDate{
  startDate:any
  endDate:any
}

@Component({
  selector: 'app-gr',
  templateUrl: './gr.component.html',
  styleUrl: './gr.component.scss'
})
export class GrComponent implements OnInit {

  @ViewChild('tt') tt?: TreeTable;
  mappedData: any[] = [];

  selectedGrData: any[] = []
  selectedPoData: any[] = [];
  plantList: any[] = [];
  poList: any[] = [];

  grList?: any[];
  cols!: Column[];
  cols1!: Column[];
  sidebarVisible: boolean = false
  rows:number=10;
  limit:number=10;
  currentPage:number=1;
  totalRecords:number=0
  grNo: string = '';
  poNo: string = '';
  GR: string = '';
  isLoading: boolean = false;

  grSearchDTO?:GRSearchDTO
  poFieldsDTOForGR?:POFieldsDTOForGR
  vendorFieldsDTOForGR?:VendorFieldsDTOForGR

  isExcel: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  dateValidation: boolean = false;
  correctDate: Date = new Date();
  constructor(
    private grIrService: GrIrService,
    private purchaseOrder: PurchaseOrderService,
    private messageService: MessageService,
    private datePipe: DatePipe,
  ) {
    this.grSearchDTO = new GRSearchDTO()
    this.poFieldsDTOForGR = new POFieldsDTOForGR()
    this.vendorFieldsDTOForGR = new VendorFieldsDTOForGR()
  }

  ngOnInit(): void {
    this.fetchData();
    this.initializeColumns();

    const selectedNo = history.state.selectedNo;
    if (selectedNo) {
    this.GR = selectedNo;
    this.fetchData().then(() => {
      history.replaceState({ ...history.state, selectedNo: null }, '');
    });
    }
  }

  initializeColumns() {
    this.cols = [
      // { field: 'status', defaultFilter:''},
      { field: 'vendor_code' ,defaultFilter:''},
      { field: 'status' ,defaultFilter:''},
      { field: 'gr_quantity' ,defaultFilter:''},
      { field: 'gr_batch_no' ,defaultFilter:''},
      { field: 'pono' ,defaultFilter:''},
      { field: 'gr_no' ,defaultFilter:''},
      { field: 'gr_date' ,defaultFilter:''},
      { field: 'gate_entry_date' ,defaultFilter:''},
      { field: 'invoice_date' ,defaultFilter:''},
      { field: 'vendor_name' ,defaultFilter:''},
      { field: 'plant' ,defaultFilter:''},
    ];
    this.cols1 = [
      // { field: 'status', defaultFilter:''},
      { field: 'vendor_code' ,defaultFilter:''},
      { field: 'plant' ,defaultFilter:''},
      { field: 'gr_no' ,defaultFilter:''},
      { field: 'vendor_name' ,defaultFilter:''},
      { field: 'gr_date' ,defaultFilter:''},
      { field: 'gr_time' ,defaultFilter:''},
      { field: 'gate_entry_date' ,defaultFilter:''},
      { field: 'invoice_date' ,defaultFilter:''},
      { field: 'gate_entry_quantity' ,defaultFilter:''},
      { field: 'ok_quantity' ,defaultFilter:''},
      { field: 'reject_quantity' ,defaultFilter:''},
      { field: 'sr_no' ,defaultFilter:''},
    ];
  }

  onInputChange(event: any, field: string) {
    const fieldMapping: { [key: string]: string } = {
      vendor_code: 'vendor_code',
      status: 'status',
      gr_quantity: 'invoice_no',
      gr_batch_no: 'invoice_date',
      pono: 'poagreement_no',
      gr_no: 'gr_no',
      gr_date: 'gr_date',
      gate_entry_date: 'gate_entry_no',
      invoice_date: 'gate_entry_date',
      vendor_name: 'business_name',
      plant: 'plant'
    };

    const inputValue = (event.target as HTMLInputElement)?.value;
    const dtoField = fieldMapping[field];
    if ("gr_no" == dtoField || "gr_date" == dtoField ||"gate_entry_no" == dtoField ||"plant" == dtoField ||"gate_entry_date" == dtoField ||"invoice_no" == dtoField ||"invoice_date" == dtoField ||"status" == dtoField) {
      (this.grSearchDTO as any)[dtoField] = inputValue;
    }
    else if ("poagreement_no" == dtoField ) {
      (this.poFieldsDTOForGR as any)[dtoField] = inputValue;
    }
    else if ("business_name" == dtoField || "vendor_code" == dtoField) {
      (this.vendorFieldsDTOForGR as any)[dtoField] = inputValue;
    }
    this.currentPage=1
    this.fetchData()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  onGlobalSearch(event: any) {
    if (event?.target?.value) {
      const searchText = event.target.value;
      this.tt?.filterGlobal(searchText, 'contains');
    }
  }

  formatDate(dateString: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero if single digit
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Pad with leading zero if single digit
    const year = date.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
}

  async fetchData() {
    try {
      let data={
        page:this.currentPage,
        limit:this.limit,
        gr_search_dto:this.grSearchDTO ,
        po_search_dto:this.poFieldsDTOForGR,
        vendor_master_search_dto:this.vendorFieldsDTOForGR,
        // po_search_dto:this.PoSearchDTO
        }
        this.isLoading=true
      const res = await this.grIrService.getGRLists(data);
      this.isLoading=false
      this.grList = res?.message.gr_list;
      this.totalRecords = res.message.total_gr
      if (this.grList) {
        this.mappedData = this.grList.map((gr: any, index: any) => {

          return {
            key: `parent_${index}`,
            data: {
              plant: gr.plant,
              gr_no: gr.gr_no,
              vendor_code: gr.vendor_code,
              vendor_name: gr.vendor_name,
              gr_date: this.formatDate(gr.gr_date),
              gr_time: gr.gr_time,
              gate_entry_date: gr.gate_entry_no,
              invoice_date: this.formatDate(gr.gate_entry_date),
              gr_quantity: gr.invoice_no,
              gr_batch_no: this.formatDate( gr.invoice_date),
              pono: gr.po_no,
              status: gr.status
            },
            children: gr.batch_detail.map((item: any, childIndex: any) => ({
              key: `child_${index}_${childIndex}`,
              data: {
                sr_no:item.sr_no ? item.sr_no : childIndex + 1,
                plant: item.po_no,
                gr_no: item.line_item_no,
                vendor_code: item.gr_material_code,
                vendor_name: item.gr_material_description,
                gr_date: item.gr_uom,
                gr_time: item.gr_storage_location,
                // gate_entry_no: item.actual_quantity,
                gate_entry_date: this.formatNumber(item.gr_line_item_quantity ?? 0),
                // invoice_no: item.batch_no,
                invoice_date: item.gr_line_item_batch_no,
                gate_entry_quantity: this.formatNumber(item.gate_entry_quantity ?? 0),
                ok_quantity: this.formatNumber(item.ok_quantity ?? 0),
                reject_quantity: this.formatNumber(item.reject_quantity ?? 0),
              },
            })).sort((a: any, b: any) => {
              // Convert sr_no to numbers for proper numerical sorting
              const srNoA = parseInt(a.data.sr_no, 10);
              const srNoB = parseInt(b.data.sr_no, 10);

              // Handle cases where sr_no might be NaN
              if (isNaN(srNoA) && isNaN(srNoB)) return 0;
              if (isNaN(srNoA)) return 1;
              if (isNaN(srNoB)) return -1;

              return srNoA - srNoB;
            }),
          };
        });
      }
      if (this.GR) {
        this.mappedData = this.mappedData.filter(data => data.data.gr_no === this.GR);
      }
    } catch (error) {
      this.isLoading=false
      console.error("Error fetching data:", error);
    }
  }

  formatNumber(value: any) {
    if (value == null) return '0.00';

    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof num !== 'number' || isNaN(num)) return value;

    // Round the number to two decimal places
    const roundedValue = Math.round(num * 100) / 100;

    const strNum = roundedValue.toString();

    // Check if it has trailing zeros after decimal or no decimal point
    if (!strNum.includes('.') || strNum.endsWith('.00')) {
      return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.fetchData()
  }

  compareItemNo(a: string, b: string): number {
    const hasUnderscoreA = a.includes('_');
    const hasUnderscoreB = b.includes('_');

    if (hasUnderscoreA && hasUnderscoreB) {
      const [prefixA, numberA] = a.split('_');
      const [prefixB, numberB] = b.split('_');

      const prefixComparison = prefixA.localeCompare(prefixB);

      if (prefixComparison !== 0) {
        return prefixComparison;
      }

      const numberComparison = parseInt(numberA, 10) - parseInt(numberB, 10);
      return numberComparison;
    } else {
      const numericComparison = parseInt(a, 10) - parseInt(b, 10);
      return numericComparison;
    }
  }

  onClickGr(rowNode: any) {
    this.selectedGrData = []
    this.selectedPoData = []
    let poNos: string[] = [];
    this.poNo =""
    // this.poNo = rowNode.node.data.pono
    this.grNo = rowNode.node.data.gr_no
    let children_data = rowNode.node.children
    this.selectedGrData.push(rowNode.node.data)
    children_data.forEach((data: any) => {
      const poNo = data.data.plant;
      if (!poNos.includes(poNo)) {
        poNos.push(poNo);
      }
      this.selectedPoData.push(data.data)
    })
    this.poNo = poNos.join(',');
    this.sidebarVisible = true;
  }

  exportToExcel(selectedGrData: any[], selectedPoData: any[]) {
    import("xlsx").then(xlsx => {
      const grSetval = selectedGrData.map(data => {
        return {
          'Plant': data['plant'],
          'GR No': data['gr_no'],
          'Vendor Code': data['vendor_code'],
          'Vendor Name': data['vendor_name'],
          'GR Date': data['gr_date'],
          'GR Time': data['gr_time'],
          'Gate Entry No': data['gate_entry_date'],
          'Gate Entry Date': data['invoice_date'],
          'Invoice No': data['gr_quantity'],
          'Invoice Date': data['gr_batch_no'],
          'Status': data['status'],
        };
      })
      const poSetVal = selectedPoData.map(data => {
        return {
          'PO No': data['plant'],
          'Line Item': data['gr_no'],
          'Material Code': data['vendor_code'],
          'Description': data['vendor_name'],
          // 'GR Qty': data['gate_entry_no'],
          'UoM': data['gr_date'],
          // 'Batch': data['invoice_no'],
          'S Loc': data['gr_time'],
          'GR Quantity': data['gate_entry_date'],
          'GR Batch No': data['invoice_date'],
          'Gate Entry Quantity': data['gate_entry_quantity'],
          'OK Quantity': data['ok_quantity'],
          'Reject Quantity': data['reject_quantity']
        };
      })
      const worksheet1 = xlsx.utils.json_to_sheet(grSetval);
      const worksheet2 = xlsx.utils.json_to_sheet(poSetVal);

      const workbook = {
        Sheets: {
          'selectedGrData': worksheet1,
          'selectedPoData': worksheet2
        },
        SheetNames: ['selectedGrData', 'selectedPoData']
      };

      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "gr");
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  transformKey(key: string): string {
    // Transform camelCase key to readable format
    return key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').toUpperCase();
  }

  exportPdf(selectedGrData: any[], selectedPoData: any[]) {
    let startY = 75;
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default('p', 'pt'); // 'p' for portrait orientation


        const fieldMapping: { [key: string]: string } = {
          plant: 'Plant',
          gr_no: 'GR No',
          vendor_code: 'Vendor Code',
          vendor_name: 'Vendor Name',
          gr_date: 'GR Date',
          gr_time: 'GR Time',
          gate_entry_date: 'Gate Entry No',
          invoice_date: 'Gate Entry Date',
          gr_quantity: 'Invoice No',
          gr_batch_no: 'Invoice Date',
          status: 'Status'
        };

        autoTable(doc, {
          // head: [['Plant', 'GR No','GR Date','GR Time','Gate Entry No','Gate Entry Date','Invoice No','Invoice Date']], // Provide a single header row for the table
          body: selectedGrData.reduce((acc: any[], item: any) => {
          Object.entries(item).forEach(([key, value]) => {
            // Convert value to string if necessary
            let valueString = value !== null && value !== undefined ? value.toString() : '';
            // Get the readable key from the mapping, default to the original key if not found
            let readableKey = fieldMapping[key] || key;
            acc.push([readableKey, valueString]);
          });
          return acc;
        }, []),
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 4, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            // Ensure data.cell.text is a string
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            // Adjust column width dynamically based on content
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1; // Assuming font size 10, adjust if needed
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height
              };
            }
          }
        });

        // Calculate the height of the first table to determine startY for the second table
        const rowCount1 = selectedGrData.length; // Assuming selectedASN is an array of objects
        const lineHeight = 12; // Adjust according to your font size and line height
        const tableHeight1 = rowCount1 * lineHeight * 200; // Estimating the table height based on row count and font size
        startY += tableHeight1 + 400; // Increased spacing between tables
        // Adding data from this.selectedASNScheduleDeliveries
        let header = "Schedule Deliveries"
        autoTable(doc, {
          head: [['PO No', 'Line Item', 'Material Code', 'Description', 'UoM', 'S Loc','GR Quantity','GR Batch No','Gate Entry Quantity','OK Quantity','Reject Quantity']],  // Provide headers from cols3
          body: selectedPoData.map(row => this.cols1.map(col => row[col.field])), // Map data to match headers
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 3, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            // Ensure data.cell.text is a string
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            // Adjust column width dynamically based on content
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1; // Assuming font size 10, adjust if needed
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height
              };
            }
          }
        });

        doc.save('gr.pdf');
      });
    });
  }

  getSeverity(status: string): string {
    if (!status) {
      return 'info';
    }



    switch (status) {
      case 'Pending For Invoice':
        return 'pendingforinvoice';
      case 'Invoiced':
        return 'invoiced';
      default:
        return 'info';
    }
  }

  getSeverityClass(severity: string): string {
    switch (severity) {
      case 'pendingforinvoice':
        return 'pendingforinvoice';
      case 'invoiced':
        return 'invoiced';
      default:
        return '';
    }
  }

  onClickExcel(){
    this.isExcel=true
  }
  onCloseForExcelReport(){
    this.isExcel=false
    this.startDate=null
    this.endDate=null
    this.dateValidation=false
  }

  onDowunloadGrListByDate(){
    if (this.startDate != null && this.endDate != null) {

    let date:FilterDate = {
      startDate:this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.isLoading=true
    this.isExcel=false
    this.grIrService.downloadGrByDate(date).then((res)=>{
      if(res.message === "No Record Found"){
        this.messageService.add({ severity: "info", summary: 'Info', detail: "No Data Found."})
      }else{
        const fileContent = res.filecontent;
        const blob = new Blob([new Uint8Array(fileContent)], {
          type: 'application/octet-stream'
        });

        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = `gr_report${date.startDate}_${date.endDate}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.messageService.add({ severity: "success", summary: 'Success', detail: "Gr Report downloaded successfully."})
      }
      this.onCloseForExcelReport();
      this.isLoading=false

    }).catch((error)=>{
      console.log(error)
    })

  }
  }

  downloadExcel() {

    // Format data for each section of the sheet
    const formattedData1 = this.formatDataForExcel(this.selectedGrData);
    const formattedData2 = this.formatDataForExcel2(this.selectedPoData);

    // Convert each formatted data to a worksheet format
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Append the first list (PO List)
    XLSX.utils.sheet_add_json(ws, formattedData1, { origin: 'A1' });

    // Auto-size columns for the first section
    this.calculateColumnWidths(ws, formattedData1);

    // Get the next available row after the first list
    const rowOffset1 = formattedData1.length + 3; // Adding 2 to leave space between sections

    // Append the second list (Item Details) below the first one
    XLSX.utils.sheet_add_json(ws, formattedData2, { origin: `A${rowOffset1}` });

    // Auto-size columns for the second section
    this.calculateColumnWidths(ws, formattedData2);

    // Create a new workbook and append the single sheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'GR Details');

    // Write the Excel file
    XLSX.writeFile(wb, 'gr_details.xlsx');
}

formatDataForExcel(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(item => ({
        'Vendor Code': item.vendor_code,
        'Plant': item.plant,
        'GR No': item.gr_no,
        'Vendor Name': item.vendor_name,
        'GR Date': item.gr_date,
        'GR Time': item.gr_time,
        'Gate Entry No': item.gate_entry_date,
        'Gate Entry Date': item.invoice_date,
        'Invoice No': item.gr_quantity,
        'Invoice Date': item.gr_batch_no,
        'Status': item.status,
    }));
}

formatDataForExcel2(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(item => ({
        'PO No': item.plant,
        'Line Item No': item.gr_no,
        'Material Code': item.vendor_code,
        'Description': item.vendor_name,
        'UoM': item.gr_date,
        'Storage Location': item.gr_time,
        'GR Quantity': item.gate_entry_date,
        'GR Batch No': item.invoice_date,
        'Gate Entry Quantity': item.gate_entry_quantity,
        'OK Quantity': item.ok_quantity,
        'Reject Quantity': item.reject_quantity,
    }));
}
  calculateColumnWidths(ws: XLSX.WorkSheet, data: any[]) {
    if (!data || data.length === 0) {
      return; // Return an empty array if data is empty or undefined
    }else{
      const colWidths: number[] = [];
      const keys = Object.keys(data[0]);

      keys.forEach((key, colIndex) => {
          let maxWidth = key.length;
          data.forEach(row => {
              maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
          });
          colWidths[colIndex] = maxWidth + 2;
      });

      ws['!cols'] = colWidths.map(width => ({ wch: width + 2 }));
    }
    }

    validateDate() {
      if (this.startDate && this.endDate) {
        const difference = this.getDateDifference();
        if (difference > 4 || this.endDate < this.startDate) {
          this.dateValidation = true;
        } else {
          this.dateValidation = false;
        }
      }
    }

    getDateDifference(): number {
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
        const diffTime = Math.abs(end.getTime() - start.getTime());
        const diffMonths = diffTime / (1000 * 3600 * 24 * 31); // approx. 30 days in a month
        return diffMonths;
      }
      return 0;
    }


}
